import URL from "core/resources/urls";
import http from "infra/http";
import { useQuery } from "react-query";
import { ConcentracaoColheita, TipoMapaTalhoes } from "../typings";

export function useConcentracaoColheita(
  unidadeId: string,
  safraId: string,
  tipoMapa: TipoMapaTalhoes
) {
  return useQuery(
    URL.MAPAS.CONCENTRACAO_COLHEITA(unidadeId!, safraId!),
    async () => {
      if (unidadeId && safraId) {
        const { data } = await http.get<ConcentracaoColheita>(
          URL.MAPAS.CONCENTRACAO_COLHEITA(unidadeId!, safraId!)
        );

        return data;
      }
    },
    {
      enabled: tipoMapa === TipoMapaTalhoes.ConcentracaoColheita,
    }
  );
}
